import { Rule } from "@fairfleet/geotab";

/** Rules created within this span of the batch's first one were created together (one setup run). */
const BATCH_SPAN_MS = 3_600_000;
/**
 * Rules sampled per batch. Without a hit the batch counts as not reprocessed and its zones get the
 * "recorded only from" notice – the safe side: a notice too many, never a silent gap.
 */
const SAMPLES_PER_BATCH = 5;

/**
 * Rules whose history was reprocessed in Geotab. No API reports a reprocessing, but it leaves stays older than
 * the rule. A zone not visited in that history has none, so a whole creation batch counts as reprocessed as
 * soon as one of its rules has such a stay – they are reprocessed together (MyGeotab → Rules → Reprocess data).
 */
export async function reprocessedRuleIds(rules: Rule[], hasStayBefore: (rule: Rule) => Promise<boolean>): Promise<Set<string>> {
  const dated = rules
    .map(rule => ({ rule, time: new Date(rule.activeFrom).getTime() }))
    .filter(entry => !Number.isNaN(entry.time))
    .sort((a, b) => a.time - b.time);

  const batches: Rule[][] = [];
  let batchStart = Number.NEGATIVE_INFINITY;
  for (const { rule, time } of dated) {
    if (time - batchStart > BATCH_SPAN_MS) {
      batches.push([]);
      batchStart = time;
    }
    batches[batches.length - 1].push(rule);
  }

  const covered = new Set<string>();
  for (const batch of batches) {
    for (const rule of batch.slice(0, SAMPLES_PER_BATCH)) {
      if (await hasStayBefore(rule)) {
        for (const member of batch) covered.add(member.id);
        break;
      }
    }
  }
  return covered;
}
